<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <b-card v-else>
            <h5 class="mb-0">
                <i class="fa fa-fw fa-refresh mr-2" />Request Overlimit
            </h5>
            <hr />
            <b-row>
                <b-col md="3">
                    <b-form-group label="Customer">
                        <div id="filter-customer">
                            <multiselect
                                id="filter-customer"
                                v-model="filter.customer"
                                label="name"
                                track-by="id"
                                :internal-search="true"
                                deselect-label=""
                                select-label=""
                                :options="optCustomer"
                            />
                        </div>
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Status">
                        <b-form-select
                            v-model="filter.status"
                            :options="optFilterStatus"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <b-button variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table
                bordered
                hover
                show-empty
                no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive
                class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada data request overlimit.
                </template>
                <template v-slot:cell(customer_name)="row">
                    {{ row.item.customer.name }}
                    <div class="small text-muted">
                        <strong>{{ row.item.customer.city }}</strong>
                    </div>
                    <div class="small text-muted">
                        {{ row.item.customer.phone }}
                    </div>
                </template>
                <template v-slot:cell(created_at)="row">
                    {{ $helper.parseDate(row.item.created_at) }},
                    {{ formatedHours(row.item.created_at) }}
                    <div class="small text-muted">
                        {{ row.item.requested_by }}
                    </div>
                </template>
                <template v-slot:cell(approved_at)="row">
                    <div v-if="row.item.approved_at != null">
                        {{ $helper.parseDate(row.item.approved_at) }},
                        {{ formatedHours(row.item.approved_at) }}
                        <div class="small text-muted">
                            {{ row.item.approved_by }}
                        </div>
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template v-slot:cell(credit)="row">
                    <div class="font-weight-bold">
                        Rp.
                        {{ $helper.formatThousand(row.item.customer.credit) }}
                    </div>
                </template>
                <template v-slot:cell(limit_credit)="row">
                    <div class="font-weight-bold">
                        Rp.
                        {{
                            $helper.formatThousand(
                                row.item.customer.limit_credit
                            )
                        }}
                    </div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge :variant="getStatusBadge(row.item.status)[0]">{{
                        getStatusBadge(row.item.status)[1]
                    }}</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <div v-if="row.item.status == 0">
                        <b-button
                            size="sm"
                            variant="success"
                            v-b-tooltip.hover.top
                            title="Terima"
                            @click="acceptRequest(row.item)"
                        >
                            <i class="fa fa-fw fa-check" />
                        </b-button>
                        <b-button
                            size="sm"
                            class="ml-2"
                            variant="danger"
                            v-b-tooltip.hover.top
                            title="Tolak"
                            @click="rejectRequest(row.item)"
                        >
                            <i class="fa fa-fw fa-times" />
                        </b-button>
                    </div>
                    <div v-else>
                        <b-button
                            size="sm"
                            variant="primary"
                            v-b-tooltip.hover.top
                            title="Detail"
                            @click="getDetail(row.item)"
                        >
                            <i class="fa fa-fw fa-info" />
                        </b-button>
                    </div>
                </template>
            </b-table>
            <PageSizer
                :totalRows="totalRows"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>
        <b-modal
            id="m-reject-overlimit"
            title="Tolak Permintaan Overlimit"
            centered
            hide-footer
        >
            <div>
                <b-form-group label="Catatan*">
                    <b-input v-model="input.note" />
                </b-form-group>
            </div>

            <b-row>
                <b-col md="12" class="text-right">
                    <b-button
                        variant="outline-primary"
                        class="mr-2"
                        :disabled="isSubmitting || !input.note"
                        @click="rejectOverlimit"
                    >
                        {{ isSubmitting ? "Mereject..." : "Reject" }}
                    </b-button>
                </b-col>
            </b-row>
        </b-modal>
        <b-modal
            id="m-approve-overlimit"
            title="Setujui Permintaan Overlimit"
            hide-footer
            centered
        >
            <p>Apakah anda yakin ingin menyetujui permintaan overlimit?</p>
            <b-row>
                <b-col md="12" class="text-right">
                    <b-button
                        variant="outline-primary"
                        class="mr-2"
                        :disabled="isSubmitting"
                        @click="approveOverlimit"
                    >
                        {{ isSubmitting ? "Menyetujui..." : "Setujui" }}
                    </b-button>
                </b-col>
            </b-row>
        </b-modal>
        <b-modal
            id="m-detail-overlimit"
            title="Informasi Request Overlimit"
            centered
            no-close-on-backdrop
            hide-footer
        >
            <div v-if="detailOverlimit && detailOverlimit.customer">
                Nama Customer:
                <strong>{{ detailOverlimit.customer.name }}</strong>
            </div>
            <div v-else>
                <p>Loading...</p>
            </div>

            <div class="mt-4">
                <div v-if="detailOverlimit">
                    <strong>Request Overlimit pada</strong><br />
                    {{ $helper.parseDate(detailOverlimit.created_at) }},
                    {{ $helper.parseHourMinute(detailOverlimit.created_at)
                    }}<br />
                </div>
            </div>

            <div class="mt-4" v-if="detailOverlimit">
                <strong>Diproses oleh / pada</strong>
                <div>
                    {{ $helper.parseDate(detailOverlimit.approved_at) }},
                    {{ $helper.parseHourMinute(detailOverlimit.approved_at)
                    }}<br />
                    oleh
                    <strong v-if="detailOverlimit.approved_by">{{
                        detailOverlimit.approved_by
                    }}</strong>
                    <strong v-else> - </strong>
                    <p>Catatan: {{ detailOverlimit.note }}</p>
                </div>
            </div>

            <div class="mt-4" v-if="detailOverlimit && detailOverlimit.invoice_summary">
                <div class="font-weight-bold">Total Item: {{ detailOverlimit.invoice_summary.total_items || "-" }}</div>
                <div class="font-weight-bold">Grand Total: Rp. {{ $helper.formatThousand(detailOverlimit.invoice_summary.total_price) }}</div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            filter: {
                status: null,
                customer: null,
            },

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" }
            ],

            fields: [
                { key: "customer_name", label: "Nama Customer", sortable: true },
                { key: "created_at", label: "Tgl.Request", sortable: true },
                { key: "approved_at", label: "Tgl.Approve", sortable: true },
                { key: "credit", label: "Piutang", sortable: true },
                { key: "limit_credit", label: "Limit Piutang", sortable: true },
                { key: "status", label: "Status", sortable: true },
                { key: "action", label: "Aksi" }
            ],

            items: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optFilterStatus: [
                { value: null, text: "Semua" },
                { value: 0, text: "Pending" },
                { value: 1, text: "Diterima" },
                { value: 2, text: "Ditolak" }
            ],

            optCustomer: [],
            input: {
                note: null,
                overlimitId: null
            },
            detailOverlimit: {}
        };
    },

    methods: {
        init() {
            this.initStatus = 0;
            let getItems = this.getItems();

            let getCustomers = this.$axios
                .get("customer/selection")
                .then(res => {
                    this.optCustomer = res.data.data;
                });

            Promise.all([getItems, getCustomers])
                .then(() => {
                    this.initStatus = 1;
                })
                .catch(_ => {
                    this.initStatus = -1;
                });
        },

        getItems(page = 1) {
            this.isBusy = true;
            this.items = [];

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage
            );

            if(this.filter.customer != null) {
                param += "&customer_id=" + this.filter.customer.id
            }

            if (this.filter.status != null) {
                param += "&status=" + this.filter.status;
            }

            if (!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy;
                param += "&sortDesc=" + this.sortDesc;
            }

            return this.$axios
                .get("overlimit-request" + param)
                .then(res => {
                    this.items = res.data.data.items;
                    this.totalRows = res.data.data.total;
                    sessionStorage.setItem(
                        "listOverlimitFilter",
                        JSON.stringify(this.filter)
                    );
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        getDetail(item) {
            this.initStatus = 0;

            this.$axios
                .get(`overlimit-request/${item.id}`)
                .then(res => {
                    this.detailOverlimit = res.data.data;
                    this.$bvModal.show("m-detail-overlimit");
                })
                .catch(error => {
                    this.$helper.toastError(
                        this,
                        "Terjadi kesalahan ketika mengambil data"
                    );
                })
                .finally(() => {
                    this.initStatus = 1;
                });
        },

        acceptRequest(item) {
            this.input.overlimitId = item.id;
            this.$bvModal.show("m-approve-overlimit");
        },

        approveOverlimit() {
            this.isSubmitting = true;

            const payload = {
                status: 1
            };

            this.$axios
                .patch(`overlimit-request/${this.input.overlimitId}`, payload)
                .then(_ => {
                    this.$bvModal.hide("m-approve-overlimit");
                    this.$helper.toastSuccess(
                        this,
                        "Permintaan overlimit berhasil disetujui!"
                    );
                    this.getItems(this.currentPage);
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        rejectRequest(item) {
            this.input.overlimitId = item.id;
            this.$bvModal.show("m-reject-overlimit");
        },

        rejectOverlimit() {
            this.isSubmitting = true;

            const payload = {
                status: 2,
                note: this.input.note
            };

            this.$axios
                .patch(`overlimit-request/${this.input.overlimitId}`, payload)
                .then(_ => {
                    this.$bvModal.hide("m-reject-overlimit");
                    this.$helper.toastSuccess(
                        this,
                        "Permintaan overlimit berhasil ditolak!"
                    );
                    this.getItems(this.currentPage);
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getItems();
        },

        getStatusBadge(status) {
            switch (status) {
                case 0:
                    return ["warning", "PENDING"];
                case 1:
                    return ["success", "DITERIMA"];
                case 2:
                    return ["danger", "DITOLAK"];
                default:
                    return ["light", "-"];
            }
        },
        formatedHours(date) {
            return new Date(date).toLocaleTimeString('id-ID', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
            timeZone: 'Asia/Jakarta'
        });
        }
    },

    created() {
        if (
            !this.$helper.isBlank(sessionStorage.getItem("listOverlimitFilter"))
        ) {
            this.filter = JSON.parse(
                sessionStorage.getItem("listOverlimitFilter")
            );
        }
        this.init();
    }
};
</script>
